/**
 * Formats a distance in metres for the radial tool's live label: metres below a
 * kilometre, kilometres above, no space before the unit (matching the legacy
 * ruler and the supplied designs). Decimal places are fixed within each band so
 * the label keeps a stable width while the radius is being dragged:
 *
 * - below 10 m: one decimal ("4.2m") so sub-metre adjustments stay visible
 * - 10 m to 1 km: whole metres ("250m")
 * - 1 km and above: two decimals ("1.27km")
 *
 * Bands are chosen on the rounded value, so a distance that rounds up to the
 * next band is displayed in that band ("999.7" -> "1.00km", never "1000m").
 */
export function formatDistance(meters: number): string {
    const clamped = Number.isFinite(meters) && meters > 0 ? meters : 0;
    if (clamped >= 999.5) {
        return `${(clamped / 1000).toFixed(2)}km`;
    }
    if (clamped >= 9.95) {
        return `${clamped.toFixed(0)}m`;
    }
    return `${clamped.toFixed(1)}m`;
}
